<template>
  <div v-html="html" class="default-wrapper wrapper"></div>
</template>

<script>
import { applySeoMeta } from '@/utils/seo';

export default {
  name: 'Page',
  props: ['pagename'],

  data() { return { html: '', lang: '', page: undefined } },

  computed: {
    isUpdate() {
      return this.$updateLang()
    },
    path() {
      return this.$route.path;
    }
  },

  watch: {
    async isUpdate() {
      await this.getPage()
    },
    async pagename(page) {
      await this.getPage(page)
    }
  },
  methods: {
    async getPage(page) {
      let query = '';
      let lang = localStorage.getItem('$lang');

      if (this.lang !== lang || page !== this.page) {
        if (lang) {
          query = `?lang=${lang}`;
        }

        try {
          const response = await fetch(`/public/template/${this.pagename}${query}`);

          if (!response.ok) {
            throw new Error('Сетевая ошибка: ' + response.statusText);
          }

          const data = await response.json();
          let name = this.$route.name;
          let settings = data && data.settings ? data.settings : {};

          applySeoMeta({
            title: settings.meta_title || name,
            description: settings.meta_description || '',
            pageType: 'page',
            pageSettings: settings,
            settings: this.$store.getters.getSettings
          });

          this.html = data.template;

        } catch (error) {
          console.error('Ошибка при получении данных:', error);
        }
      }
      this.page = page;
      this.lang = lang;
    }
  },

  async mounted() {
    await this.getPage(this.pagename);
  }
}
</script>